import React from 'react';
import { connect } from 'react-redux';

import StatusTable from './components/StatusTable';

const UrlStatus = ({ publushSummary, authHeader }) => {

  return (
    <>
      <div>
        {authHeader && <StatusTable tableRowData={publushSummary} />}
      </div>
    </>
  );
};

const mapStateToProps = ({
  authentication: { authHeader },
  URLs: { publushSummary } }) => ({
    publushSummary,
    authHeader
  });

export default connect(mapStateToProps)(UrlStatus);
